import { Component, OnInit } from '@angular/core';
import { Paginacao } from '../../comum/modelos/paginacao';
import { RegiaoService } from '../regiao.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { RegiaoCliente } from '../../comum/modelos/regiao-cliente';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { ConfirmationService } from 'primeng/primeng';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-listar-regioes',
  templateUrl: './listar-regioes.component.html',
  styleUrls: ['./listar-regioes.component.css']
})
export class ListarRegioesComponent implements OnInit {

  filtroPesquisaNomeRegiao: string;

  regioesCliente: RegiaoCliente[];

  paginacao: Paginacao;

  evento: Evento;

  selecionados: boolean;
  statusCode: number;
  public loading = false;

  constructor(private _regiaoService: RegiaoService,
    private _comumService: ComumService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.paginacao = new Paginacao();
    this.regioesCliente = new Array<RegiaoCliente>();
    this.evento = this._comumService.evento;
    if (this.evento !== undefined) {
      setTimeout(() => {
        this._comumService.cleanEvent();
      }, 3000);
    }

  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;

    const self = this;
    const idCliente = parseInt(this._cookieService.get('idCliente'));
    const sc = this._regiaoService.obterRegioesClienteHttp(idCliente);
    const s = this._regiaoService.obterRegioesHttp();

    forkJoin(s, sc)
      .subscribe(([regioes, regioesCliente]) => {
        for (const regiao of regioes) {
          const novaRegiaoCliente = new RegiaoCliente();
          novaRegiaoCliente.regiao = regiao;
          novaRegiaoCliente.idCliente = idCliente;
          for (const regiaoCliente of regioesCliente) {
            if (regiaoCliente.regiao.idRegiao === regiao.idRegiao) {
              novaRegiaoCliente.idRegiaoCliente = regiaoCliente.idRegiaoCliente;
              novaRegiaoCliente.selecionado = true;
              break;
            }
          }
          self.regioesCliente.push(novaRegiaoCliente);
        }
        self.loading = false;
      });
  }

  removerRegiao(regiaoCliente: RegiaoCliente): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir a regi\u00e3o?',
      accept: () => {
        this.loading = true;
        this._regiaoService.removerRegiaoHttp(regiaoCliente.regiao.idRegiao).subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.deletar = true;
          this.removerRegiaoFromList(this.regioesCliente, regiaoCliente);
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        }, errorCode => {
          this.statusCode = errorCode;
          this._comumService.evento.deletar = true;
          this._comumService.evento.error = true;
          this.loading = false;
          setTimeout(() => {
            this.evento.limparEventos();
          }, 3000);
        });
      },
      reject: () => {
      }
    });

  }

  removerRegiaoFromList(regioesCliente: RegiaoCliente[], regiaoCliente: RegiaoCliente): void {
    const index = this.obterIdRegiao(regioesCliente, regiaoCliente);
    regioesCliente.splice(index, 1);
  }

  obterIdRegiao(regioesCliente: RegiaoCliente[], regiaoCliente: RegiaoCliente): number {
    return regioesCliente.indexOf(regiaoCliente);
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaNomeRegiao = filtro.value;
  }

  limparPesquisaPorFiltro(filtro: any): void {
    filtro.value = '';
    this.pesquisarPorFiltro(filtro);
  }

  selecionar(regiaoCliente: RegiaoCliente): void {
    regiaoCliente.selecionado = !regiaoCliente.selecionado;
    regiaoCliente.alterado = true;
  }

  selecionarTodos(): void {
    this.selecionados = !this.selecionados;
    this.regioesCliente.forEach(regiaoCliente => {
      regiaoCliente.selecionado = this.selecionados;
      regiaoCliente.alterado = true;
    });
  }

  onSubmit(): void {
    this.loading = true;
    const regioesClienteInsert = new Array<RegiaoCliente>();
    const regioesClienteRemove = new Array<RegiaoCliente>();
    this.regioesCliente.forEach(regiaoCliente => {
      if (!regiaoCliente.selecionado && regiaoCliente.idRegiaoCliente !== undefined && regiaoCliente.alterado) {
        regioesClienteRemove.push(regiaoCliente);
      } else if (regiaoCliente.selecionado && regiaoCliente.idRegiaoCliente === undefined
        && regiaoCliente.alterado) {
        regioesClienteInsert.push(regiaoCliente);
      }
    });
    if (regioesClienteRemove.length > 0) {
      this._regiaoService.removerRegioesClienteHttp(regioesClienteRemove)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-regioes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    if (regioesClienteInsert.length > 0) {
      this._regiaoService.cadastrarRegioesClienteHttp(regioesClienteInsert)
        .subscribe(response => {
          this.loading = false;
          this.statusCode = response.status;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-regioes']);
        }, errorCode => {
          this.statusCode = errorCode;
          this.loading = false;
        });
    }
    this.loading = false;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/regiao/listar-regioes/listar-regioes.component.ts